import React from 'react';
import { useTranslation } from 'react-i18next';
import AppCard from 'components/@common/Cards/AppCard';
import PageContainer from 'components/@layout/PageContainer';
import useStore from 'store';
import { PliManagedApp } from 'store/cache/product-cache';
import { ModuleProps } from 'types';
import getApplicationType from 'utilities/get-application-type';
import HeaderBar from '../HeaderBar';
import AppCardContainer from './components/AppCardContainer';

const AppAccess: React.FC<ModuleProps> = props => {
  const { t } = useTranslation('AppAccess');
  const [{ productCache }] = useStore();
  const apps = productCache.getApps();

  const renderAppCard = (pliManagedApp: PliManagedApp) => {
    const appType = pliManagedApp.type ? t(getApplicationType([pliManagedApp.type])) : undefined;

    return (
      <AppCard
        key={`app-${pliManagedApp.app.name}${
          pliManagedApp.appProduct?.product?.code ? `-${pliManagedApp.appProduct.product.code}` : ''
        }`}
        href={`/app-access/${pliManagedApp.appProduct?.product?.code ?? pliManagedApp.app.name}`}
        src={pliManagedApp.accessDetails?.bannerUrl}
        title={pliManagedApp.title}
        subtitle={appType}
        description={pliManagedApp.description}
      />
    );
  };

  return (
    <PageContainer loading={!apps}>
      <HeaderBar {...props} />
      <AppCardContainer>{apps && apps.map(renderAppCard)}</AppCardContainer>
    </PageContainer>
  );
};

export default AppAccess;
